// Shared dashboard card header: accent icon badge, title, optional right slot
// and a refresh button.
import { Box, Flex, IconButton, Spinner, Text, useColorModeValue } from "@chakra-ui/react";
import { MdRefresh } from "react-icons/md";

/**
 * Renders a card header with a tinted icon badge, a title, an optional
 * right-aligned node (year label, selector...) and an optional refresh button.
 * @param {Object} props - icon (component), title, accent (icon color),
 *   right (node), onRefresh (callback), loading (bool)
 * @returns {React.ReactElement}
 */
export default function CardHeader({ icon: Icon, title, accent = "brand.500", right, onRefresh, loading }) {
  const badgeBg = useColorModeValue("secondaryGray.300", "navy.700");
  const titleColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Flex align="center" justify="space-between" mb="14px">
      <Flex align="center" gap="10px" minW="0">
        <Flex align="center" justify="center" w="38px" h="38px" borderRadius="12px"
          bg={badgeBg} flexShrink="0">
          <Box as={Icon} fontSize="20px" color={accent} />
        </Flex>
        <Text fontSize="md" fontWeight="700" color={titleColor} noOfLines={1}>{title}</Text>
      </Flex>
      <Flex align="center" gap="4px" flexShrink="0">
        {right}
        {onRefresh && (
          <IconButton aria-label="Rafraîchir" size="sm" variant="ghost" isDisabled={loading}
            onClick={onRefresh}
            icon={loading ? <Spinner size="sm" /> : <Box as={MdRefresh} fontSize="18px" />} />
        )}
      </Flex>
    </Flex>
  );
}
